import { render, staticRenderFns } from "./SlideConfiguration.vue?vue&type=template&id=fda57646&scoped=true"
import script from "./SlideConfiguration.vue?vue&type=script&lang=js"
export * from "./SlideConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SlideConfiguration.vue?vue&type=style&index=0&id=fda57646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda57646",
  null
  
)

export default component.exports